import { useContext, useState } from 'react';
import { AppContext } from '../../../bootstrap/App';
import { updateUser, type User as ApiUser } from '../../../helper/api';

/**
 * Update the current signed-in user data
 */
function useSetCurrentUserData() {
  const { user, setUser } = useContext(AppContext);
  const [loading, setLoading] = useState(false);

  const setData = async (data: Array<{ name: string; value: unknown }>) => {
    if (!user) {
      console.error('No user available to update');
      return;
    }

    setLoading(true);

    try {
      // Convert the data array to a user update object with proper typing
      const updateData: Partial<ApiUser> = {};
      data.forEach(({ name, value }) => {
        if ((name === 'createdAt' || name === 'updatedAt') && value instanceof Date) {
          (updateData as any)[name] = value.toISOString();
        } else {
          (updateData as any)[name] = value;
        }
      });

      // Update user via API
      const updatedUser = await updateUser(updateData);

      // Update local user state with the response, converting date strings back to Date objects
      const userUpdate: any = {
        ...updatedUser,
        ...(updatedUser.createdAt && { createdAt: new Date(updatedUser.createdAt) }),
        accessToken: user.accessToken, // Preserve the access token
      };

      setUser({
        ...user,
        ...userUpdate,
      });
    } catch (error) {
      console.error('Failed to update user data:', error);
    } finally {
      setLoading(false);
    }
  };

  return { setData, loading };
}

export default useSetCurrentUserData;
